class AccordionV2 extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('[data-accordion-v2-toggle]');
    this.rows = Array.from(this.querySelectorAll('[data-accordion-v2-row]'));
    this.initialCount = parseInt(this.dataset.initialCount, 10) || this.rows.length;
    this.moreText = this.dataset.moreText || 'See More FAQs';
    this.lessText = this.dataset.lessText || 'See Less FAQs';
    this.expanded = false;

    this.applyVisibility();

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.applyVisibility();
      });
    }
  }

  applyVisibility() {
    this.rows.forEach((row, index) => {
      if (this.expanded || index < this.initialCount) {
        row.style.display = '';
        row.removeAttribute('hidden');
      } else {
        row.style.display = 'none';
        row.setAttribute('hidden', '');
      }
    });

    if (this.toggleBtn) {
      if (this.rows.length <= this.initialCount) {
        this.toggleBtn.style.display = 'none';
      } else {
        this.toggleBtn.style.display = '';
        this.toggleBtn.textContent = this.expanded ? this.lessText : this.moreText;
      }
    }
  }
}

class AccordionV2Row extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    if (this.summary) {
      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });
    }
  }

  toggle() {
    if (!this.details) return;

    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.details.open = true;
    this.details.classList.add('is-open');
    const content = this.details.querySelector('.accordion-v2__content');
    if (content) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  close() {
    const content = this.details.querySelector('.accordion-v2__content');
    if (content) {
      content.style.maxHeight = '0px';
    }
    this.details.classList.remove('is-open');
    setTimeout(() => {
      this.details.open = false;
    }, 300);
  }
}

if (!customElements.get('accordion-v2')) {
  customElements.define('accordion-v2', AccordionV2);
}

if (!customElements.get('accordion-v2-row')) {
  customElements.define('accordion-v2-row', AccordionV2Row);
}
